import { endpoint } from '@/services/api/endpoint';

import {
  JeHeadersConfigPropagateBodySchema,
  JeHeadersConfigPropagateResponseSchema,
  JeHeadersConfigSaveBodySchema,
  JeHeadersConfigSaveResponseSchema,
  JeHeadersConfigsQuerySchema,
  JeHeadersConfigsResponseSchema,
} from '@/domain/jeFieldRearrangement/schemas';

export const jeFieldRearrangementApi = {
  getConfigs: endpoint({
    method: 'GET',
    url: 'configs',
    query: JeHeadersConfigsQuerySchema,
    response: JeHeadersConfigsResponseSchema,
  }),
  saveConfig: endpoint({
    method: 'POST',
    url: 'configs',
    query: JeHeadersConfigsQuerySchema,
    body: JeHeadersConfigSaveBodySchema,
    response: JeHeadersConfigSaveResponseSchema,
  }),
  propagateConfig: endpoint({
    method: 'POST',
    url: 'configs/propagate',
    body: JeHeadersConfigPropagateBodySchema,
    response: JeHeadersConfigPropagateResponseSchema,
  }),
};
